import { request } from '@/api/index'
//招标采购
export function queryGGlist(filter) {
  return request({
    url: `/api/ep/hy/v1.0/portal/one/gglist/list`,
    method: 'post',
    data: filter
  })
}
export function queryGGBillList(filter){
  return request({
      url: `/api/ep/hy/v1.0/portal/one/gglist/cqgglist`,
      method: 'post',
      data: filter
  })
}
export function queryZQGGBillList(filter){
  return request({
    url: `/api/ep/hy/v1.0/portal/one/gglist/cqzqgglist`,
    method: 'post',
    data: filter
  })
}
export function queryAgencyList(filter){
  return request({
    url: `/api/ep/hy/v1.0/portal/one/gglist/cqagencylist`,
    method: 'post',
    data: filter
  })
}
export function querySupplierList(filter){
  return request({
    url: `/api/ep/hy/v1.0/portal/one/supplierinfo/cqsupplierlist`,
    method: 'post',
    data: filter
  })
}
export function getDetails(ggId) {
  return request({
    url: `/api/ep/hy/v1.0/portal/one/gglist/detail?ggid=`+ggId,
    method: 'get'
  })
}
export function getGGDetails(ggId) {
  return request({
    url: `/api/ep/hy/v1.0/portal/one/gglist/cqggdetail?ggid=`+ggId,
    method: 'get'
  })
}
export function getCQDetails(ggId,ggType) {
  return request({
    url: `/api/ep/hy/v1.0/portal/one/gglist/cqdetail?ggid=`+ggId+'&ggtype='+ggType,
    method: 'get'
  })
}
//新闻资讯
export function getNewsDetail(newsid) {
  return request({
    url: `/api/ep/hy/v1.0/portal/one/news/newsdetail?newsid=`+newsid,
    method: 'get',
  })
}
export function getNewsList() {
  return request({
    url: `/api/ep/hy/v1.0/portal/one/news/newslist`,
    method: 'get',
  })
}

export function getnewslistbycat(filter) {
  return request({
    url: `/api/ep/hy/v1.0/portal/one/news/getcqnewslistbycat`,
    method: 'post',
    data: filter
  })
}

export function getNewsPageList(filter) {
  return request({
    url: `/api/ep/hy/v1.0/portal/one/news/newspagelist`,
    method: 'post',
    data: filter
  })
}
export function getNewsByCats(filter) {
  return request({
    url: `/api/ep/hy/v1.0/portal/one/news/getcqnewsbycat`,
    method: 'post',
    data: filter
  })
}

//图片获取
export function getNewsImg(newsid) {
  return request({
    url: `/api/ep/hy/v1.0/portal/one/news/newsimg?newsId=`+newsid,
    method: 'get'
  })
}
export function getFileInfo(billId){
  return request({
    url: `/api/ep/hy/v1.0/portal/one/file/bybillid?billid=`+billId,
    method: 'get'
  })
}
export function downloadFile(fileId){
  return request({
    url: `/api/ep/hy/v1.0/portal/one/news/downloadfile?fileId=`+fileId,
    method: 'get'
  })
}

//帮助中心
export function getHelpsByCat() {
  return request({
      url: `/api/ep/hy/v1.0/portal/one/news/gethelpsbycat`,
      method: 'get',
  })
}
export function getHelpsDetail(helpsId) {
  return request({
      url: `/api/ep/hy/v1.0/portal/one/news/helpsdetail?helpsId=`+helpsId,
      method: 'get',
  })
}

export function getNewscontent() {
  return request({
    url: `/api/ep/hy/v1.0/portal/one/news/newscontent`,
    method: 'get',
  })
}

export function getStatistics(){
  return request({
    url: `/api/ep/hy/v1.0/portal/one/statistics/transactiondata`,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/api.js